const n = (r, e) => e[r], o = (r, e) => e[r];
export {
  n as mapTriggerEnumToLabel,
  o as mapTriggerOperationToLabel
};
